import * as sup from "superstruct";

import { createResourceStruct } from "@/modules/api/utils/jsonApiStructs";
import { attachmentIdentifierStruct } from "@/modules/attachment/attachmentIdentifierStruct";

import { handbookIdentifierStruct } from "./handbookIdentifierStruct";

export const handbookResourceStruct = createResourceStruct({
  identifier: handbookIdentifierStruct,
  attributes: sup.object({
    name: sup.string(),
  }),
  relationships: sup.object({
    attachment: sup.object({
      data: attachmentIdentifierStruct,
    }),
  }),
});

export type HandbookResource = sup.Infer<typeof handbookResourceStruct>;
